import propTypes from 'prop-types';
import { Container } from './Containers';
import Header from './Header';
import Plan from './Plan';
import Slider from './Slider';

export default function Skeleton({ isLargeScreen }) {
	const getContainer = (key, highlight = false) => (
		<Container key={key} highlight={highlight} loading={true}>
			<Header />
			<div className="prc-content">
				<Plan loading={true} highlight={highlight ? ' ' : ''} />
			</div>
		</Container>
	);

	const containers = [false, true, false].map((container, i) => getContainer(i, container));
	return isLargeScreen ? containers : <Slider slides={containers} />;
}

Skeleton.propTypes = {
	isLargeScreen: propTypes.bool,
};
